<template>
  <div></div>
</template>
<script>
// redirect router && some common css
/**
 * global 司机注册，fleet相关逻辑如下
 * 1.helpDriverReg=1 driverLeaderTicket=xxx，车头帮司机注册并绑定，走登录流程，带上ticket
 * 2.车头帮助司机修改资料，传参iDriverId，API兼容id获取数据，无需登录
 * 3.车头升级身份，传参 roleTrans=1、ticket--车头自己ticekt
 */
import { mapState, mapMutations } from "vuex";
import { SUPPORT_COUNTRY as sc, OLD_REGISTER_URL } from "../tools/constant";
import { post } from "../tools/request";
import { setTitle } from "../tools/setTitle";
import { getEnd } from "../tools/utils";
import { LOGIN_CONFIG, ends, OPEN_COUNTRY } from "../tools/constant";
import { showLoadingToast, showAlertDialog, showDialog } from "../tools/Tip";
// import { getEnd } from "../../../document-expired/src/tools/utils";

export default {
  data() {
    return {
      whatsapp_register: true, // @20191120 全量放开wa入口
      skip_pwd: true, //@20200512 全量密码后置
    };
  },
  computed: {
    ...mapState(["_ticket", "_product", "_landing_H5_1110", "_ru_fleet_driver_role_divison_test", "_landing_page_open_switch", "_mx_landingpage_h5_0302", "_mx_landingpage_wa_0302"]),
    params() {
      return new URLSearchParams(location.search);
    },
    paramObj() {
      const _paramObj = {};
      for (let [key, value] of this.params) {
        _paramObj[key] = decodeURIComponent(value);
      }
      return _paramObj;
    },
    ticket() {
      if (this._ticket) {
        return this._ticket;
      } else {
        if (!ends.isPassengerTerminal || this.oasis) {
          return this.params.get("ticket") || this.params.get("token");
        }
        return "";
      }
    },
    product() {
      //产品线巴西从URL中取，其他国家从vuex取
      //@20190416 巴西也可能从vuex取，（新流程），兼容从老系统来的数据，20191024 重新启用
      if (this.country === "BR") {
        return this.params.get("product") || this._product;
        //@20190904 巴西产品线信息目前只会存在于URL，需等待日后pop、taxi迁移完毕
        // return this.params.get("product");
      }
      return this._product;
    },
    country() {
      return this.params.get("location_country");
    },
    oasis() {
      return this.params.get("business_line") === "oasis";
    },
    end() {
        return this.params.get("end");
    },
    routes() {
      // @20210113 开国配置化，默认走global --Mx
      let r = sc[this.country] || "Mx";
      return {
        prepareInfo: `prepareInfo${r}`,
        productInfo: `productInfo${r}`,
        productInfoNew: `productInfo`,
        typeInfo: `typeInfo${r}`,
        typeInfoNew: `typeInfo`,
        basicInfo: `baseInfo`,
        auditInfo: `photoInfo`,
        result: `result${r}`,
        downloadInfo: `downloadInfo`,
        resultInfo: `resultRoleInfo`,
        workInfo: 'workInfo',
      };
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    goProcess() {
      // showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      //兼容多个国家情况，重新设置ticket
      if (this.ticket) {
        up.set("ticket", this.ticket);
      }
      post(process.env.GET_PROGRESS_URL, up)
        .then((data) => {
          // @20201126 ios global司机端&澳新司机端内不展示help入口 （临时处理）
          let terminal_id = this.params.get("terminal_id");
          let is_global_driver_app = terminal_id == 9 || terminal_id == 10;
          this.handleHelpAB(data.progress);
          // if (!(ends.inApp && !ends.isAndroid && is_global_driver_app)) {
          //   this.handleHelpAB(data.progress);
          // }

          this.$nextTick(() => {
            //@20190904 处理巴西AB实验
            if (
              this.country === "BR" &&
              data.progress === "productInfo" &&
              !this.whatsapp_register
            ) {
              data.progress = "basicInfo";
            }
            this.setState({
              _role_page_skip: data.role_page_skip || {},
            });
            //@20200227 处理乘客端,端内vamos业务--基础信息页之前多一个准备页
            // @20201118 暂时注掉准备页，为注册引流
            // @20210118 放开准备页入口
            // @20210902 再次下掉准备页(之前放开准备页是因为准备页上有入口可以跳过注册，现在下掉准备页也可以跳过注册流程了)
            // if (
            //   ends.isPassengerTerminal &&
            //   this.oasis &&
            //   data.progress === "basicInfo"
            // ) {
            //   this.$router.replace({ name: this.routes["prepareInfo"] });
            //   return;
            // }

            // @20201019 新增车头推荐页
            if (data.progress === "fleetRecommendInfo") {
              // 来源是注册审核
              if ([11, 12].includes(data.identity_driver_role)) {
                up.set("identity_driver_role", data.identity_driver_role);
              }
              up.set("from_business_type", "register");
              location.href = `${process.env.FLEET_URL}?${up.toString()}`;
              return;
            }
            //@20200929 俄罗斯fleet driver从fms注册来的跳转到fms url
            if (
              (this.country === "RU" || this.country == "KZ" || this.country == "UA") &&
              data.progress === "fleetDirverConfirmInfo" &&
              data.fleetDirverSkipUrl
            ) {
              let fmsUrl = data.fleetDirverSkipUrl;
              location.href =
                fmsUrl.indexOf("?") > -1
                  ? `${fmsUrl}&${up}`
                  : `${fmsUrl}?${up}`;
              return;
            }
            // @20210510 端内实验chatBot, 对话方式注册实验
            if (data.progress === "chatBot" ) {
              location.href = `${process.env.CHATBOT_URL}?${up.toString()}`;
              return;
            }
            this.$router.replace({ name: this.routes[data.progress] });
          });
        })
        .catch((err) => showAlertDialog(this))
        .finally(() => {
          // this.toast.hide();
        });
    },
    toggle() {
      showLoadingToast(this);
      post(
        process.env.TOGGLE_API,
        new URLSearchParams({
          ticket: this.ticket,
          product: this.product,
          location_country: this.country,
        })
      )
        .then((data) => {
          //true --新页面
          if (data.toggle) {
            this.goProcess();
          } else {
            let up = new URLSearchParams(location.search);
            //兼容使用token的case
            up.set("ticket", this.ticket);
            if (this.country === "BR") {
              up.set("product", data.product);
              up.set("product_id", data.product);
              let cMap = {
                1: "taxi",
                2: "pop",
                3: "top",
              };
              up.set("category", cMap[data.product]);
            }
            location.href = `${OLD_REGISTER_URL[this.country]}?${up}`;
          }
        })
        .catch((err) => showAlertDialog(this))
        .finally(() => {
          this.toast.hide();
        });
    },
    checkProduct() {
      showLoadingToast(this);
      post(
        process.env.GET_PRODUCT_URL,
        new URLSearchParams({
          ticket: this.ticket,
          location_country: this.country,
        })
      )
        .then((data) => {
          //0 ,1,2,3
          const cMap = {
            1: "TAXI",
            2: "POP",
            3: "TOP",
          };
          if (data.product == 0 || data.product == this.product) {
            this.toggle();
          } else {
            showDialog(this, {
              content: this.$t("产品线选择错误").replace(
                /\{category\}/,
                cMap[data.product]
              ),
              icon: "cubeic-info",
              confirmBtn: {
                text: this.$t("确认"),
              },
              onConfirm: () => {
                //BR 专有
                this.$router.replace({ name: "loginBr" });
                // //去除产品线产品，让用户重新选择
                // let up = new URLSearchParams(location.search);
                // up.delete("product");
                // up.delete("product_id");
                // up.delete("category");
                // location.href = `${location.protocol}//${location.host}${location.pathname}?${up}`;
              },
            });
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.toast.hide();
        });
    },
    handleWhatsappApollo() {
      post(
        process.env.AB_URL,
        new URLSearchParams({
          experiment_key: "whatsapp_volume_guide_br",
          individual_id: Omega.getOmgid(),
          location_country: this.country,
        })
      )
        .then((data) => {
          this.setState({
            _showWa: data.group_name === "treatment_group",
          });
        })
        .catch((err) => console.log(err));
    },
    handleBrLawAB() {
      post(
        process.env.AB_URL,
        new URLSearchParams({
          experiment_key: "passport_frontpage_agreement_check",
          individual_id: Omega.getOmgid(),
          location_country: this.country,
        })
      )
        .then((data) => {
          this.setState({
            _law_checked: data.group_name === "treatment_group",
          });
        })
        .catch((err) => console.log(err));
    },
    handleWa() {
      let that = this;
      window.Apollo.getToggle(
        {
          name: "ibt_wa_register",
          location_country: "BR",
          key: Omega.getOmgid(),
          device_id: Omega.getOmgid(),
        },
        function (result) {
          if (!result.code) {
            var toggle = result.data.ibt_wa_register; // 或者 result.data['exp_or_toggle_name']
            if (toggle) {
              if (toggle.isAllow()) {
                // 进入灰度
                that.setState({
                  _showWa: toggle.groupName === "control_group",
                });
              }
            } else {
              // 没有找到开关命名，请检查是否在正确的环境下创建了开关
              console.log("toggle not found");
            }
          } else {
            // 请求出错，这里可以获得错误code和message
            console.log("code: " + result.code + ", " + result.message);
          }
        }
      );
    },
    //统一处理AB实验入口
    // oid
    handleMixAB(cb) {
      showLoadingToast(this);
      let experiment_key = "homepage_phone_input_optimization,mx_landing_page_oid";
      // @20220125 new landingpage实验全量，实验请求下线
      // if (this.end !== 'WhatsappEnd') {
      //   experiment_key += ',landing_H5_1110';
      // }
      // @20220311 mx new landingpage实验
      // @20220523 mx new landingpage实验全量
      if (this.params.get('from_end') !== 'WhatsappConf') {
        // experiment_key += ',landing_page_open_switch,mx_landingpage_h5_0302';
        experiment_key += ',landing_page_open_switch';
      } else {
        // experiment_key += ',mx_landingpage_wa_0302';
      }
      post(
        process.env.AB_MIX,
        new URLSearchParams({
          experiment_key,
          individual_id: Omega.getOmgid(),
          location_country: this.country,
        })
      )
        .then((data) => {
          this.setState({
            _phone_focus:
              data.homepage_phone_input_optimization.is_treatment_group,
            _phone_focus_global: data.mx_landing_page_oid.is_treatment_group,
            // _ru_se_driver_switch_test:
            //   data.ru_se_driver_switch_test.is_treatment_group,
            // _ru_fleet_driver_role_divison_test: data.ru_fleet_driver_role_divison_test.is_treatment_group,
            // _landing_H5_1110: data.landing_H5_1110 ? data.landing_H5_1110.is_treatment_group : false,
            _landing_page_open_switch: data.landing_page_open_switch ? data.landing_page_open_switch.is_treatment_group : false,
            // _login_btn_text: data.signup_button_copy_change.is_treatment_group,
            // _auto_submit: data.submit_basic_infro_popup.is_treatment_group,
            _mx_landingpage_wa_0302: this.country === 'MX',
            _mx_landingpage_h5_0302: this.country === 'MX',
          });
          // RU和UA默认角色是有车司机,其他国家角色默认是3-车主
          if (['UA', 'RU'].includes(this.country)) {
            this.setState({
              _identity: "11",
            });
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally((x) => {
          this.toast.hide();
          cb && cb();
        });
    },
    // 统一处理BR uidAB实验入口
    // 巴西角色选择页、产品线选择页文案AB实验
    handleMixABUid(cb) {
      // showLoadingToast(this);
      post(
        process.env.AB_MIX_UID,
        new URLSearchParams({
          experiment_key: "BR_driverRole_WenAn,MX_driver_role_WenAn",
          individual_id: Omega.getOmgid(),
          location_country: this.country,
          ticket: this.ticket,
        })
      )
        .then((data) => {
          this.setState({
            _br_type_product_text: data.BR_driverRole_WenAn.is_treatment_group,
            _mx_type_product_text: data.MX_driver_role_WenAn.is_treatment_group,
          });
        })
        .catch((err) => console.log(err))
        .finally((x) => {
          // this.toast.hide();
          cb && cb();
        });
    },
    // help入口实验(passport之后的流程)
    handleHelpAB(progress) {
      post(
        process.env.HELP_AB_TEST,
        new URLSearchParams({
          page_type: progress,
          oid: Omega.getOmgid(),
          end: getEnd(),
          location_country: this.country,
          ticket: this.ticket,
        })
      )
        .then((data) => {
          this.setState({
            _help_icon: data.hasHelpButton,
            _help_icon_url: data.url,
            _help_icon_icon_url: data.icon_url,
          });
        })
        .catch((err) => {
          this.setState({
            _help_icon: false,
            _help_icon_url: '',
            _help_icon_icon_url: '',
          });
        });
    },
    // help入口实验(passport之前的页面)
    handleHelpABBefore() {
      let push_drstrange_version = this.params.get("push_drstrange_version")
      post(
        process.env.HELP_AB_TEST_BEFORE,
        new URLSearchParams({
          oid: Omega.getOmgid(),
          end: getEnd(),
          location_country: this.country,
          ...(push_drstrange_version ? {
            push_drstrange_version
          } : {})
        })
      )
        .then((data) => {
          this.setState({
            _help_icon: data.hasHelpButton,
            _help_icon_url: data.url,
            _help_icon_icon_url: data.icon_url,
          });
        })
        .catch((err) => {
          this.setState({
            _help_icon: false,
            _help_icon_url: '',
            _help_icon_icon_url: '',
          });
        });
    },
    handleBr() {
      if (!this.ticket) {
        //@20191024 调整BR登录方式
        let c = {
          ...LOGIN_CONFIG["COMMON"],
          ...window.didii18nconfig[this.country],
          ...LOGIN_CONFIG[this.country],
          skip_set_password: this.skip_pwd,
          extra_info: {
            ...this.paramObj
          }
        }
        //@20211217 BR新增fleet业务，支持强制验证码登录
        if (this.params.get("helpDriverReg") == 1) {
          c["appid"] = 120022;
        }
        login.setConfig(c);

        if (this.params.get("helpDriverReg") == 1 || ends.isPC) {
          //1.fleet端车头帮助司机注册，并绑定司机、2.PC端流量，以上2种情形需要重新登录
          this.$nextTick(() => this.$router.replace({ name: "loginBrWhatsapp" }));
          return;
        }
        if (this.params.get("iDriverId")) {
          //fleet 端，车头帮司机修改资料
          this.goProcess();
          return;
        }

        //@20190904 B组新流程，如果ticket已存在则直接进入产品线选择
        // let rou = this.whatsapp_register
        //   ? this.ticket
        //     ? "productInfoBr"
        //     : "loginBrWhatsapp"
        //   : "loginBr";
        // this.$nextTick(() => this.$router.replace({ name: rou }));
        // @20191024 流程调整
        // if (this.whatsapp_register) {
          login.isLogin(
            (res) => {
              if (res.login) {
                this.setState({
                  _ticket: res.ticket,
                  _cell: res.cell,
                  _uuid: res.uid,
                });
                // this.toggle();
                // @20231229 去掉放量&实验接口
                // this.handleMixABUid(null);
                this.goProcess();
              } else {
                // @2022 0112 newLandingPage全量
                // this.$router.replace({ name: this._landing_H5_1110 || this.end === "WhatsappEnd" ? "newLandingPage" : "loginBrWhatsapp" });
                if (this.params.get("hasBrFleetReg") == 1) {
                  this.handleHelpABBefore();
                  this.$router.replace({ name: "loginBrWhatsapp" });
                  return
                } else if (this.params.get("from_end") === 'WhatsappConf' || this._landing_page_open_switch) {
                  this.$router.replace({ name: "loginMxComp" });
                  return
                } else {
                  this.$router.replace({ name: "newLandingPage" });
                  return
                }
              }
            },
            (err) => {
              console.log(err);
              showAlertDialog(this, this.$t("login_error"));
            }
          );
        // } else {
        //   this.$nextTick(() => this.$router.replace({ name: "loginBr" }));
        // }
      } else {
        //第一步判断产品线，不一致则抛错，跳转至重新选择页;第二步走流量开关，决定新老页面
        //@20191024 根据AB实验来调整流程
        // if (this.whatsapp_register) {
        //   // this.toggle();
        //   this.handleMixABUid(null);
        //   this.goProcess();
        // } else {
        //   this.checkProduct();
        // }
        // @20231229 去掉放量&实验接口
        // this.handleMixABUid(null);
        this.goProcess();
      }
    },
    handleOasis(country) {
      //顺风车业务线11
      this.setState({
        _product: 11,
      });
      if (!this.ticket) {
        if(country == "BR"){
          //巴西的单独处理 其余为global
          login.setConfig({
            ...LOGIN_CONFIG["COMMON"],
            ...LOGIN_CONFIG["BR_oasis"],
          });
          login.isLogin(
          (res) => {
            if (res.login) {
              this.setState({
                _ticket: res.ticket,
                _cell: res.cell,
                _uuid: res.uid,
              });
              this.goProcess();
            } else {
              this.$router.replace({ name: "loginBrWhatsapp" });
            }
          },
          (err) => {
            console.log(err);
            showAlertDialog(this, this.$t("login_error"));
          }
        );
        }else{
          login.setConfig({
            ...LOGIN_CONFIG["COMMON"],
            ...LOGIN_CONFIG[country],
            ...LOGIN_CONFIG["Global_oasis"]
          });
          login.isLogin(
          (res) => {
            if (res.login) {
              this.setState({
                _ticket: res.ticket,
                _cell: res.cell,
                _uuid: res.uid,
              });
              this.goProcess();
            } else {
              this.$router.replace({ name: "loginMx" });
            }
          },
          (err) => {
            console.log(err);
            showAlertDialog(this, this.$t("login_error"));
          }
        );
        }

      } else {
        this.goProcess();
      }
    },
    handleMx() {
      //_ticket 是登录后 store 内的存储，可信任
      if (this.ticket) {
        // uid实验
        // @20231229 去掉放量&实验接口
        // this.handleMixABUid(null);
        this.goProcess();
      } else {
        let c = {
          ...LOGIN_CONFIG["COMMON"],
          ...window.didii18nconfig[this.country],
          ...LOGIN_CONFIG[this.country],
          skip_set_password: this.skip_pwd,
          extra_info: {
            ...this.paramObj
          }
        };
        //@20200316 处理fleet业务，支持强制验证码登录
        if (this.params.get("helpDriverReg") == 1) {
          c["appid"] = 120022;
        }
        login.setConfig(c);

        if (this.params.get("helpDriverReg") == 1 || ends.isPC) {
          //1.fleet端车头帮助司机注册，并绑定司机、2.PC端流量，以上2种情形需要重新登录
          if (OPEN_COUNTRY.includes(this.country)) {
            this.$nextTick(() => this.$router.replace({ name: "loginMx" }));
          } else {
            this.$nextTick(() => this.$router.replace({ name: "login" }));
          }
          return;
        }
        if (this.params.get("iDriverId")) {
          //fleet 端，车头帮司机修改资料
          this.goProcess();
          // this.$nextTick(() =>
          //   this.$router.replace({ name: "photoInfoMx" })
          // )
          return;
        }
        login.isLogin(
          (res) => {
            if (res.login) {
              this.setState({
                _ticket: res.ticket,
                _cell: res.cell,
                _uuid: res.uid,
              });
              // uid实验
              // @20231229 去掉放量&实验接口
              // this.handleMixABUid(null);
              this.goProcess();
            } else {
              // if (this._mx_landingpage_h5_0302 || this._mx_landingpage_wa_0302) {
              //   this.$router.replace({ name: "newLandingPage" });
              //   return
              // }
              if (this.params.get("from_end") === 'WhatsappConf' || this._landing_page_open_switch) {
                this.$router.replace({ name: "loginMxComp" });
                return
              }
              this.handleHelpABBefore();
              if (OPEN_COUNTRY.includes(this.country)) {
                this.$router.replace({ name: "loginMx" });
              } else {
                this.$router.replace({ name: "login" });
              }

            }
          },
          (err) => {
            console.log(err);
            showAlertDialog(this, this.$t("login_error"));
          }
        );
      }
    },
    handleAu() {
      //_ticket 是登录后 store 内的存储，可信任
      if (this.ticket) {
        // this.toggle();
        this.goProcess();
      } else {
        login.setConfig({
          ...LOGIN_CONFIG["COMMON"],
          ...window.didii18nconfig[this.country],
          ...LOGIN_CONFIG[this.country],
          extra_info: {
            ...this.paramObj
          }
        });

        if (ends.isPC) {
          //PC端流量，以上情形需要重新登录
          this.$nextTick(() => this.$router.replace({ name: "loginAu" }));
          return;
        }
        login.isLogin(
          (res) => {
            if (res.login) {
              this.setState({
                _ticket: res.ticket,
                _cell: res.cell,
                _uuid: res.uid,
              });
              // this.toggle();
              this.goProcess();
            } else {
              if (this.params.get("from_end") === 'WhatsappConf' || this._landing_page_open_switch) {
                this.$router.replace({ name: "loginMxComp" });
                return
              } else {
                this.$router.replace({ name: "loginAu" });
                return
              }
            }
          },
          (err) => {
            console.log(err);
            showAlertDialog(this, this.$t("login_error"));
          }
        );
      }
    },
    goPrePage() {
      console.log(this.$route.name)
      this.$router.replace({ name: this.$route.name });
    },
  },
  mounted() {
    //设置当前环境默认标题
    setTitle(this.$t("page_title"));
    // 俄罗斯、哈萨克、南非下线OB功能
    if (['RU', 'KZ', 'ZA'].includes(this.country)) {
      showAlertDialog(this, this.$t('GDriver_down_Sorry_your_fAUS'), this.$t('GDriver_down_well_DlVp'));
      return;
    }
    // @20210209 preview是用于配置平台的预览页面
    if (this.params.get('ob_page_type') === 'preview') {
      this.goPrePage();
      return;
    }
    //不同国家走不同逻辑
    let c = this.country;
    // @20191205 所有国家均新增oid上报接口，在巴西调开关控制的接口里同时实现了
    // @20220123 巴西bbb大促护堤下掉该实验，该实验已关闭
    // this.handleWhatsappApollo();
    // @202107 顺风车单独判断
    if(this.oasis){
        this.handleOasis(c);
    // if (c === "BR") {
    //   // this.handleBrLawAB();
    //   if (this.oasis) {
    //     this.handleOasis(c);
    //   } else {
    //     // this.handleBrMixAB();
    //     this.handleMixAB(this.handleBr);
    //     // this.handleBr();
    //   }
    } else if (c === "BR") {
      // this.handleMixAB(this.handleBr);
      // @20231229 去掉放量&实验接口
      this.handleBr();
      ends.isFleetApp && this.setState({
        _identity: "13",
      });
      ends.isFleetApp && this.params.get("helpDriverReg") == 1 && this.setState({
        _identity: "1",
      });
    } else if (c === "AU" || c === "NZ") {
      // this.handleMixAB(this.handleAu);
      // @20231229 去掉放量&实验接口
      this.handleAu()
    } else if (c == "RU" || c == "UA") {
      // if (this.params.get("qatest") != "1") {
      //   return;
      // }
      //默认车头,@20200827 默认改为司机
      this.setState({
        _identity: "1",
      });
      this.handleMixAB(this.handleMx);
    } else if (this.params.get("terminal_id") == 5) {
      //@2020106 特殊处理BR包
      let up = new URLSearchParams(location.search);
      up.set("location_country", "BR");
      location.href = `${location.protocol}//${location.host}${location.pathname}?${up}`;
    } else {
      // 20210113 开国配置化，默认走global--Mx
      // this.handleMixAB(this.handleMx);
      // @20231229 去掉放量&实验接口
      this.handleMx();
    }
    // URL上如果有product和identity,用它给store赋值
    const u_identity = this.params.get('identity');
    const u_product = this.params.get('product');
    u_identity && this.setState({
      _identity: u_identity,
    });
    u_product && this.setState({
      _product: u_product
    });
  },
};
</script>

